import React from 'react';
import { colors } from './theme';

// Shared model-status indicator. state: 'loading' | 'ready' | 'hidden'
const ModelStatus = ({ state }) => {
  if (!state || state === 'hidden') return null;
  const isReady = state === 'ready';
  // Status line, not a control — white like the other headings and messages,
  // with gold reserved for things you can press.
  const { emphasis: accent, border } = colors;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 12,
        color: accent,
        fontSize: 15,
        letterSpacing: 0.4,
        fontWeight: 600,
      }}
    >
      {isReady ? (
        <svg
          aria-hidden="true"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          style={{ stroke: accent }}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : (
        <svg
          aria-hidden="true"
          width="20"
          height="20"
          viewBox="0 0 50 50"
          style={{ animation: 'mstatus-spin 1s linear infinite' }}
        >
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            style={{ stroke: border }}
            strokeWidth="4"
          />
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            style={{ stroke: accent }}
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="90 150"
          />
        </svg>
      )}
      <span>{isReady ? 'Model ready!' : 'Model loading…'}</span>
      <style>{`
        @keyframes mstatus-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ModelStatus;
